import Datepicker from "./../components/datepicker";
import Modal from "./../components/BsModal.vue";
import Heading from "./../components/heading";
import ProductImagesSlider from "../components/ProductImagesSlider.vue";
import ExpandableContent from '../components/ExpandableContent.vue';
import BaseSlider from '../components/NewTemplate/BaseSlider';
import Helpers from "../../../shared/helpers";
import TrackViewItemHelper from "../../../shared/js/DL-shared-events";
import AccordionInfo from "../../../shared/js/components/AccordionInfo.vue";
import HideDigiohIntentMixin from "../mixins/digioh-intent-mixin.js";
import AvailabilityBadge from "../../../shared/js/components/AvailabilityBadge.vue";
import AvailabilityBadgeSo from "../../../shared/js/components/AvailabilityBadgeSo.vue";
import AvailabilityMessage from "../../../shared/js/components/AvailabilityMessage.vue";
import AvailabilityReservation from "../../../shared/js/components/AvailabilityReservation.vue";
import ProductLocationMap from "../../../shared/js/components/ProductLocationMap.vue";
import { withIterableSearchIdentity } from "../../../shared/js/iterableSearchIdentity";

Vue.component('page-lot', {

	components: {
		AccordionInfo,
		Modal,
		ProductImagesSlider,
		ExpandableContent,
		BaseSlider,
		AvailabilityBadge,
		AvailabilityBadgeSo,
		AvailabilityMessage,
		AvailabilityReservation,
		ProductLocationMap
	},

	mixins: [Datepicker, Heading, Helpers, TrackViewItemHelper, HideDigiohIntentMixin],

	data: function () {
		return {
			checkin_value: '',
			checkout_value: '',

			showFooter: false,

			lot_list: {},
			soldOut: false,
			step: 1,

			showAllPhotos: false,
			parking_max: 0,
			alternatives: apr.content.alternatives,
			alternatives_count: apr.alternatives_count,

			search: {
				checkindate: {},
				checkoutdate: {},
				checkintime: {
					default: '12:00:00'
				},
				checkouttime: {
					default: '12:00:00'
				}
			},
			name: apr.content.parkinglot.name,
			rate: apr.content.parkinglot.rate,
			content: apr.content,
			parkinglot: apr.content.parkinglot,
			options: apr.content.parkinglot.options,
			searchbox: null,
			working: false,
			products: [],
			product: null, // selected product_id

			// cloneed form checkout
			errorTimes: null,
			errorTimesMessage: '',
			errorCheckInTime: null,
			errorCheckOutTime: null,
			errorNoTimes: null,
			warningShuttleTimes: false,
			warningShuttleTimesMessage: '',
			searchPermitted: false,

			times: apr.times,

			isUpdateTimesInProgress: false,
			proceedToCheckout: false,
			initSlider: false,
			productsSliderKey: 0,
			showMoreReviews: false,
    	}
	},

	mounted() {
		let self = this

		$(document).on('shown.bs.modal', '#Gallery_Modal', () => {
			this.initSlider = true;
		});

		this.$root.$on('session-received', function (data) {
			if (data.searchbox) {
				self.searchbox = data.searchbox
				self.checkin_value = data.searchbox.checkindate;
				self.checkout_value = data.searchbox.checkoutdate;
				self.initDateComponent(data)
			} else {
				self.searchPermitted = true
			}
		})

		this.initSearchboxDatepickers($('.checkout'))
		this.initPagination()

		$('body').addClass('showFooter')

		// this.createWaypoints()
		// this.scrollStick();
		this.trackLogoClick();

		window.addEventListener('pageshow', function () {
			self.proceedToCheckout = false;
			$('button').prop('disabled', false);
		});

		$('#Select_Parking').on('hide.bs.modal', function () {
			self.resetValidationErrors();
			self.proceedToCheckout = false;
			$('button').prop('disabled', false);

			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Parkinglot',
				'EventAction': 'Modal - Closed modal',
				'EventLabel': ''
			})
		})

		$('body').scrollspy({target: '#navbar-sticky', offset: 50})

		$("#Select_Parking").on('hidden.bs.modal', function (e) {
			self.step = 1;
			self.proceedToCheckout = false;
			$('button').prop('disabled', false);
		})

		if (apr.show_datepicker) {
			this.focusDate();
		}

		this.$nextTick(function () {
			setTimeout(function () {
				let checkinDate  = self.parseDateTime(_.get(self, 'searchbox.checkindate'), _.get(self, 'searchbox.checkintime'));
				let checkoutDate = self.parseDateTime(_.get(self, 'searchbox.checkoutdate'), _.get(self, 'searchbox.checkouttime'));
				let isTimesValid = _.get(checkinDate, 'date') && checkinDate.isValid() && _.get(checkoutDate, 'date') && checkoutDate.isValid();

				let stayDuration = isTimesValid ? (checkoutDate.diff(checkinDate, 'days') + 1) : null;
				let daysAheadOfBooking = isTimesValid ? (checkinDate.diff(moment(), 'days') + 1) : null;

				dataLayer.push({
					'event': 'globalParameters',
					'airportCode': `${self.content.airport.code}`,
					'airportName': `${self.content.airport.fullname}`,
					'parkingDepartureDate': isTimesValid ? checkinDate.format("YYYY-MM-DD") : null,
					'parkingReturnDate': isTimesValid ? checkoutDate.format("YYYY-MM-DD") : null,
					'parkingDepartureTime': isTimesValid ? checkinDate.format("HH:mm") : null,
					'parkingReturnTime': isTimesValid ? checkoutDate.format("HH:mm") : null,
					'daysAheadOfBooking': daysAheadOfBooking,
					'stayDuration': stayDuration,
					'carParkName': `${self.content.airport.code} ${apr.content.parkinglot.name}`,
					'couponVoucher': null,
					'loginStatus': apr.logged_in ? 'Logged in' : null,
					'partnerName': null,
					'serviceType': 'parking',
					'siteLanguage': 'en-GB',
					'bookingType': 'APR',
				});

				self.trackViewItemAPR();
			}, 5 * 1000);
		});
	},

	watch: {
		'search.checkintime.default': () => {
			$('#timepicker1_v2').blur()
		},

		'search.checkouttime.default': () => {
			$('#timepicker2_v2').blur()
		},

		checkout_value(val) {
			if (val && this.checkin_value && this.searchPermitted) {
				this.updateSearchDates()
			}
		},
	},

	computed: {
		checkInTimes() {
			return apr.times
		},

		checkOutTimes() {
			return apr.times
		},

		reviews() {
			return this.showMoreReviews ? this.content.reviews.data : this.content.reviews.data.slice(0, 3);
		},

	 	recommendedLots() {
			return this.alternatives.filter((alternative) => alternative.provider === 'APR').slice(0, 9);
		},

		recommendedHotels() {
			return this.alternatives.filter((alternative) => alternative.provider === 'PSF').slice(0, 9);
		},

		selectedProduct() {
			return this.products.find(product => product.id === this.product);
		}
	},

	methods: {
		trackLogoClick() {
			$(document).on('click', '.navbar .navbar-brand', () => {
				dataLayer.push({
					'event': 'GaEvent',
					'EventCategory': 'Logo click',
					'EventAction': 'Click desktop',
					'EventLabel': ''
				})
			})
		},

		createWaypoints() {
			var waypoint = new Waypoint({
				element: $('#dates-component'),
				handler: function (direction) {
					if (direction == "down") {
						$('#dates-component').addClass('sticky')
					} else {
						$('#dates-component').removeClass('sticky')
					}
				}
			})

			var waypoint = new Waypoint({
				element: $('#navbar-sticky'),
				handler: function (direction) {
					if (direction == "down") {
						$('#navbar-sticky').addClass('sticky')
					} else {
						$('#navbar-sticky').removeClass('sticky')
					}
				}
			})
		},

		scrollStick() {
			$(window).scroll(function () {
				var height = $(window).scrollTop();
				var datesComp = $('.dates-container').offset();
				var navbarComp = $('.navbar-container').offset();
				if (height > datesComp.top) {
					$('#dates-component').addClass('sticky')
				} else {
					$('#dates-component').removeClass('sticky')
				}
				if (height > navbarComp.top) {
					$('#navbar-sticky').addClass('sticky')
				} else {
					$('#navbar-sticky').removeClass('sticky')
				}
			});
		},

		scrollPassedDates() {
			console.log('In Dates')
		},

		initPagination() {
			let page = this.getQueryVariable('reviews')

			if (page) {
				this.paginationLink(window.location.href, false)
			} else {
				this.appendPaginationLinks()
			}
		},

		initDateComponent(data) {
			if (data.searchbox.token) {
				this.working = true
				this.$http.put(`/parkinglot/${apr.content.parkinglot.id}/search/${data.searchbox.token}`, {
					checkindate: this.searchbox.checkindate,
					checkoutdate: this.searchbox.checkoutdate,
				}).then((response) => {
					this.alternatives = _.get(response, 'body.alternatives');
					this.parkinglot = response.body.parkinglot
					this.airportCode = response.body.search.data.airport.data.code
					this.options = response.body.parkinglot.options
					this.search = response.body.search.data
					this.products = response.body.parkinglot.products.data
					this.working = false
					this.searchPermitted = true
					this.setSelectPlaceholders();

					this.initBackButton(response)
					this.productsSliderKey += 1;
					this.updateTimesInExperiment();

				}, (response) => {
					this.soldOut = true;
					this.working = false;
				})
			}
		},

		initBackButton(response) {
			// http://pastebin.com/EZ2Ka1DG
			let airportCode = response.body.search.data.airport.data.code.toLowerCase()

			let productUrl = window.location.href;
			let airportUrl = `/search/${airportCode}?token=${response.body.search.data.token}`;
			window.history.replaceState({action: "airport"}, "", airportUrl);
			window.history.pushState({action: "product"}, "", productUrl);

			window.addEventListener("popstate", function (event) {
				if (event.state && event.state.action === "airport") {
					window.location = airportUrl;
				}
			}, false);
		},

		searchLink() {
			if (this.searchbox) {
				return `/search/${this.content.airport.code}/?token=${this.searchbox.token}`
			}
		},

		updateSearchDates() {
			this.working = true
			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Parkinglot',
				'EventAction': 'Calendar dates edited',
				'EventLabel': ''
			})
			if (!this.parkinglot.service && this.parkinglot.on_airport) {
				return this.searchParking()
			}

			if (this.search.token) {
				this.$http.put(`/parkinglot/${apr.content.parkinglot.id}/search/${this.search.token}`, {
					checkindate: this.checkin_value,
					checkoutdate: this.checkout_value,
				}).then((response) => {
					this.alternatives = response.body.alternatives
					this.options = response.body.parkinglot.options
					this.parkinglot = response.body.parkinglot
					this.airportCode = response.body.search.data.airport.data.code
					this.working = false
					this.search = response.body.search.data
					this.setSelectPlaceholders()
					$('html,body').animate({scrollTop: 0}, 'slow');
					this.productsSliderKey += 1;
				}, (response) => {
					this.working = false
					if (response.body.data) {
						window.location.href = this.redirectToSearch(response.body.data[0].data.token)
					}
				})
			} else {
				this.$http.post(`/parkinglot/${apr.content.parkinglot.id}/search`, withIterableSearchIdentity({
					checkindate: this.checkin_value,
					checkoutdate: this.checkout_value,
				})).then((response) => {
					this.alternatives = response.body.alternatives
					this.options = response.body.parkinglot.options
					this.parkinglot = response.body.parkinglot
					this.airportCode = response.body.search.data.airport.data.code
					this.working = false
					this.search = response.body.search.data
					this.setSelectPlaceholders()
					this.updateTimesInExperiment()
					$('html,body').animate({scrollTop: 0}, 'slow');
					this.productsSliderKey += 1;
				}, (response) => {
					this.working = false
					if (response.body.data) {
						window.location.href = this.redirectToSearch(response.body.data[0].data.token)
					}
				})
			}
		},

		updateTimes() {
			this.errorTimes = false
			this.errorNoTimes = false
			this.warningShuttleTimes = false

			this.resetValidationErrors();

			if (this.isUpdateTimesInProgress) {
				return
			}

			if (this.search.checkintime.default == '' && this.search.checkouttime.default == '') {
				this.errorNoTimes = 'both'
				return
			} else if (this.search.checkintime.default == '') {
				this.errorNoTimes = 'check-in'
				return
			} else if (this.search.checkouttime.default == '') {
				this.errorNoTimes = 'check-out'
				return
			}

			if (this.$ldClient.isInExperiment('CRO_950_APR_DEFAULT_ENTRY_EXIT_TIME')) {
				this.$ldClient.track('time-modal-continue-btn-clicked');
			}

			this.isUpdateTimesInProgress = true
			this.$http.put(`/parkinglot/${apr.content.parkinglot.id}/search/${this.search.token}?filter_by_parkinglot_id=true`, {
				checkintime: this.search.checkintime.default,
				checkouttime: this.search.checkouttime.default,
				checkindate: this.search.checkindate.date_format_1,
				checkoutdate: this.search.checkoutdate.date_format_1,
			}).then((response) => {
				this.isUpdateTimesInProgress = false
				this.search = response.body.search.data
				this.step++
				this.errorNoTimes = null

				if (response.body.search.product) {
					this.product = response.body.search.product
				} else {
					this.products = response.data.parkinglot.products.data
					if (Array.isArray(response.body.parkinglot.products.data)) {
						this.product = response.body.parkinglot.products.data[0].id
					} else {
						this.product = response.body.parkinglot.products.data[1].id
					}
				}

				this.products = response.body.parkinglot.products.data

				let checkinDate = moment(this.search.checkindate.date_format_2, 'MMM DD, YYYY');
				let checkoutDate = moment(this.search.checkoutdate.date_format_2, 'MMM DD, YYYY');
				let stayDuration = checkoutDate.diff(checkinDate, 'days') + 1;
				let daysAheadOfBooking = checkinDate.diff(moment(), 'days') + 1;

				dataLayer.push({
					event: 'parkingTimes',
					parkingDepartureTime: this.search.checkintime.standard_time,
					parkingReturnTime: this.search.checkouttime.standard_time,
					stayDuration: stayDuration,
					daysAheadOfBooking: daysAheadOfBooking,
				});

				if (response.body.warning) {
					this.warningShuttleTimes = true;
					this.warningShuttleTimesMessage = response.body.warning.times.message;
					this.errorCheckInTime = response.body.warning.times.checkin;
					this.errorCheckOutTime = response.body.warning.times.checkout;
				}
			}, (response) => {

				this.isUpdateTimesInProgress = false
				if (response.body.checkintime && response.body.checkouttime) {
					this.errorNoTimes = 'both'
					return
				} else if (response.body.checkintime) {
					this.errorNoTimes = 'check-in'
					return
				} else if (response.body.checkouttime) {
					this.errorNoTimes = 'check-out'
					return
				}

				this.errorNoTimes = null

				if (response.body.data) {
					let errors = _.get(response.body.data, '0.errors');
					if (errors) {
						for (var errorName in errors) {
							let $field = $("#Select_Parking").find(`[name="${errorName}"]`);

							if ($field.length) {
								$field.parsley().addError('custom-error', {message: errors[errorName]});
							}
						}
						return;
					}

					if (_.get(response.body.data[0], 'data.unavailable_for_selected_times') === true) {
						this.errorTimes = true;
						this.errorTimesMessage = _.get(response.body.data[0], 'data.message');

						dataLayer.push({
							'event': 'GaEvent',
							'EventCategory': 'Parkinglot',
							'EventAction': 'Modal - Times Unavailable',
							'EventLabel': ''
						})
					} else {
						let token = _.get(
							response.body.data[0],
							'data.token',
							this.searchbox.token
						)

						window.location.href = this.redirectToSearch(token)
					}
				}
			})

			//dataLayer - checkout step1 - Parking Times
			let providerName = _.get(self.apr.content.parkinglot, 'provider');
			let category = this.getLotCategory(providerName);
			let $discountPriceBlock = $('.strikeout').parent().find('span:nth-child(2) > strong');
			let price = $discountPriceBlock.length === 1
				? parseFloat($discountPriceBlock.html().replace("$", ""))
				: self.apr.content.parkinglot.rate;
			dataLayer.push({
				'event': 'checkout',
				'ecommerce': {
					'checkout': {
						'actionField': {'step': 1, 'option': 'Parking Times'},
						'products': [{
							'name': `${this.content.airport.code} ${self.apr.content.parkinglot.name}`,
							'id': self.apr.content.parkinglot.id,
							'price': price,
							'brand': '',
							'category': category,
							'variant': '',
							'quantity': 1
						}]
					}
				}
			})
		},

		resetValidationErrors() {
			let $errors = $(".parsley-error");
			if ($errors.length) {
				$errors.parsley().reset();
			}
		},

		setSelectPlaceholders() {
			// for vue - to select default values
			if (this.search.checkintime.default === null || this.search.checkintime.default === undefined) {
				this.search.checkintime.default = '12:00:00'
			}

			if (this.search.checkouttime.default === null || this.search.checkouttime.default === undefined) {
				this.search.checkouttime.default = '12:00:00'
			}

			const timeWithoutSecondsPattern = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])$/;

			if (timeWithoutSecondsPattern.test(this.search.checkintime.default)) {
				this.search.checkintime.default += ':00'
			}

			if (timeWithoutSecondsPattern.test(this.search.checkouttime.default)) {
				this.search.checkouttime.default += ':00'
			}
		},

		showTimesModal() {
			if (!this.checkin_value || !this.checkout_value) {
				return this.focusDate()
			}

			$('#Edit_Times, #Select_Parking').modal('show')
		},

		goToCarouselSlide(index) {
			$('.carousel').carousel(index)
			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Parkinglot',
				'EventAction': 'Photos',
				'EventLabel': 'Next'
			})
		},

		selectProduct(productId) {
			this.product = productId
			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Parkinglot',
				'EventAction': 'Modal - Parking Type Selected',
				'EventLabel': ''
			})
		},

		redirectToSearch(token) {
			sessionStorage.removeItem('session');
			return `/search/soldout?token=${token}&airport=${this.content.airport.code}&parkinglot=${this.parkinglot.name}`
		},

		searchPath() {
			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Parkinglot',
				'EventAction': 'Modal - Times Unavailable - Link Clicked ',
				'EventLabel': ''
			})
			window.location.href = `/search/${this.content.airport.code}?token=${this.search.token}`
		},

		goToCheckout() {
			this.proceedToCheckout = true
			$('button').prop('disabled', true)

			this.$http.put(`/parkinglot/${apr.content.parkinglot.id}/search/${this.search.token}/product`, {
				product: this.product
			}).then((response) => {
				dataLayer.push({
					'event': 'GaEvent',
					'EventCategory': 'Parkinglot',
					'EventAction': 'Modal - Proceeded To Checkout',
					'EventLabel': ''
				})

				//dataLayer - checkout step2 - Parking Type
                let providerName = _.get(self.apr.content.parkinglot, 'provider');
                let category = this.getLotCategory(providerName);
				let price = this.selectedProduct.rate

				dataLayer.push({
					'event': 'checkout',
					'ecommerce': {
						'checkout': {
							'actionField': {'step': 2, 'option': 'Parking Type'},
							'products': [{
								'name': `${this.content.airport.code} ${self.apr.content.parkinglot.name}`,
								'id': self.apr.content.parkinglot.id,
								'price': price,
								'brand': '',
								'category': category,
								'variant': '',
								'quantity': 1
							}]
						}
					}
				})


				let priceUsd = _.get(this, 'selectedProduct.rate_usd', null);
				let airportCode = _.get(this, 'content.airport.code', '');
				let parkinglotName = _.get(apr, 'content.parkinglot.name', '');
				let itemBrand = _.get(apr, 'content.parkinglot.name', null);
				let itemName = `${airportCode} ${parkinglotName}`;

				dataLayer.push({ ecommerce: null });
				dataLayer.push({
					event: 'add_to_cart',
					ecommerce: {
						currency: 'USD',
						value: priceUsd,
						items: [
							{
								item_id: apr.content.parkinglot.id,
								item_name: itemName,
								coupon: null,
								discount: null,
								index: 0,
								item_brand: itemBrand,
								item_category: 'Airport Parking Only',
								item_category2: null,
								item_category3: null,
								item_category4: null,
								item_category5: null,
								item_variant: 'available',
								price: priceUsd,
								quantity: 1
							},
						],
					}
				});

				window.location.href = this.checkoutLocation(response)
			}, (response) => {
				$('button').prop('disabled', false)
				alert('Sorry we are unable to process you request.')
				this.proceedToCheckout = false
			})
		},

		searchParking() {
			let self = this
			this.working = true

			let searchURL = `${apr.app_url}/search`;
			let searchParams = withIterableSearchIdentity({
				airport: apr.content.airport.code,
				package: 'APR',
				date1: this.checkin_value,
				date2: this.checkout_value,
				guests: 2,
				rooms: 1,
				hotel_id: 0,
				checkindate: this.checkin_value,
				checkoutdate: this.checkout_value,
			});

			this.$http.post(searchURL, searchParams).then((response) => {
				if (response.data.redirect) {
					window.location.href = response.data.redirect
				} else if (response.data.data.redirect_url) {
					window.location.href = response.data.data.redirect_url
				}
				setTimeout(() => {
					self.inProgressSearch = false;
				}, 7500)
			})
		},

		appendPaginationLinks() {
			$('link[rel=next], link[rel=prev]').remove();

			if (this.content.reviews.next_page_url) {
				$('head').append(`<link rel="next" href="${this.content.reviews.next_page_url}" />`)
			}

			if (this.content.reviews.prev_page_url) {
				$('head').append(`<link rel="prev" href="${this.content.reviews.prev_page_url}" />`)
			}
		},

		paginationLink(link, push) {
			if (link) {
				this.$http.get(link).then((response) => {
					this.content = response.data
					this.appendPaginationLinks()

					if (push) {
						$('html, body').animate({scrollTop: $("#reviews").offset().top}, 500)
					}

				}, (response) => {
					alert('Sorry we could not get that page for you')
				})
			}
		},

		focusDate() {
			$("body").animate({scrollTop: 0}, 1000);
			setTimeout(() => {
				$("input[name='checkindate']").trigger('click')
				dataLayer.push({
					'event': 'GaEvent',
					'EventCategory': 'Parkinglot',
					'EventAction': 'Calendar dates edited',
					'EventLabel': ''
				})
			}, 100)
		},

		setDates(start, end) {
			this.checkin_value = start
			this.checkout_value = end
		},

		formatDate(date) {
			if (date) {
				return moment(date).format(window.APR_DATE_FORMAT2);
			}
			return ''
		},

		checkoutLocation(response) {
			let payment = this.parkinglot.prepaid ? 'prepaid' : 'deposit'

			return `${apr.app_url}/checkout/${payment}?token=${this.search.token}`;
		},

		registerTabEvent(event) {
			// $("html,body").animate({ scrollTop: $(`#${event.toLowerCase()}`).offset().top - 48 }, "slow");
			this.scrollTo(event.toLowerCase())
			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Parkinglot',
				'EventAction': 'Tabs',
				'EventLabel': event
			})
		},

		scrollTo(id) {
      $("html,body").animate({scrollTop: $(`#${id}`).offset().top - 48}, "slow");
    },

		editTimes() {
			this.step = 1
			this.warningShuttleTimes = false
			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Parkinglot',
				'EventAction': 'Modal - Edit Times',
				'EventLabel': ''
			})
		},

		alternativeSelected(name) {
			dataLayer.push({
				'event': 'GaEvent',
				'EventCategory': 'Parkinglot',
				'EventAction': 'Alternative parking lot selected',
				'EventLabel': name
			})
		},

		registerEvent(name) {
			dataLayer.push({'event': 'GaEvent', 'EventCategory': 'Parkinglot', 'EventAction': name, 'EventLabel': ''})
		},

		isOneDateSearch() {
			return this.search.checkindate.date_format_1 === this.search.checkoutdate.date_format_1;
		},

		updateTimesInExperiment() {
			const isDefaultTimes = (this.search.checkintime.default === "12:00 PM" && this.search.checkouttime.default === "12:00 PM") ||
				(this.search.checkintime.default === '12:00:00' && this.search.checkouttime.default === '12:00:00');
			if (this.$ldClient.getFeatureFlag('CRO_950_APR_DEFAULT_ENTRY_EXIT_TIME', true) === false && isDefaultTimes) {
				this.search.checkintime.default = '';
				this.search.checkouttime.default = '';
			}
		},

		parseDateTime(dateStr, timeStr) {
			if (!dateStr || !timeStr) {
				return { date: null, time: null };
			}

			return moment(`${dateStr} ${timeStr}`, "MMM D, YYYY h:mm A");
		}
	}
});
